<template>
  <div class="paper_entry_box">
    <div class="screen_box">
      <a-select
        :value="props.batchIndex"
        :options="props.batchList"
        size="large"
        style="min-width: 200px"
        placeholder="请选择"
        @change="batchChange"
      >
      </a-select>

      <div class="screen_item">
        <div class="label">专业层次：</div>
        <a-select
          v-model:value="selectVal.level"
          :options="options.level"
          size="large"
          style="min-width: 110px"
          placeholder="请选择"
          @change="levelChange"
        >
        </a-select>
      </div>
      <div class="screen_item">
        <div class="label">专业名称：</div>
        <a-select
          v-model:value="selectVal.majorId"
          :options="options.majorList"
          size="large"
          style="min-width: 210px"
          placeholder="请选择"
          @change="majorChange"
        >
        </a-select>
      </div>
    </div>

    <div class="data_box" v-if="options.majorList.length">
      <div class="view_box">
        <div class="title_box">
          <img class="img" src="@/assets/t_icon.png" alt="" />
          <span>论文考试报名</span>
        </div>
        <a-descriptions
          title=""
          bordered
          :column="2"
          :labelStyle="{
            'text-align': 'right',
            color: '#666666',
            width: '170px',
          }"
          :contentStyle="{ color: '#666666', flex: '1' }"
        >
          <a-descriptions-item :column="1" label="论文报名起止时间">
            <div class="value_box">
              {{
                timeFormat2(
                  props.batchData.signUpStartTime,
                  props.batchData.signUpEndTime
                )
              }}
              <span class="des_item_s1 ml10" @click="noticeChange('signNotice')"
                >报名须知</span
              >
            </div>
          </a-descriptions-item>
          <!-- 报名状态 -->
          <a-descriptions-item :column="1">
            <template #label>
              <span>
                {{ signUpData.stateObj[options.majorData.isSignUp].state }}
              </span>
            </template>
            <div class="value_box">
              <span class="des_item_s1" @click="operateChange()">
                {{ signUpData.stateObj[options.majorData.isSignUp].txt }}
              </span>
            </div>
          </a-descriptions-item>
          <template v-if="props.batchData.enablePay">
            <a-descriptions-item :column="1" label="论文缴费起止时间">
              <div class="value_box">
                {{
                  timeFormat2(
                    props.batchData.payStartTime,
                    props.batchData.payEndTime
                  )
                }}
                <span
                  class="des_item_s1 ml10"
                  @click="noticeChange('payNotice')"
                >
                  缴费须知
                </span>
              </div>
            </a-descriptions-item>
            <a-descriptions-item :column="1" label="缴费金额">
              <div class="value_box">
                {{ `${props.batchData.signUpPay}元` || "无需缴费" }}
              </div>
            </a-descriptions-item>
          </template>
        </a-descriptions>
      </div>

      <div class="view_box">
        <div class="title_box">
          <img class="img" src="@/assets/t_icon.png" alt="" />
          <span>本学期的论文计划</span>
        </div>
        <a-descriptions
          title=""
          bordered
          :column="2"
          :labelStyle="{
            'text-align': 'right',
            color: '#666666',
            width: '170px',
          }"
          :contentStyle="{ color: '#666666', flex: '1' }"
        >
          <a-descriptions-item
            :column="1"
            label="开题报告提交时间"
            v-if="props.batchData.proposalReport"
          >
            <div class="value_box">
              {{
                timeFormat2(
                  props.batchData.proposalReportStartTime,
                  props.batchData.proposalReportEndTime
                )
              }}
              <span
                class="des_item_s1 ml10"
                @click="noticeChange('proposalReportNotice')"
                >开题须知</span
              >
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="一稿论文提交时间">
            <div class="value_box">
              {{
                timeFormat2(
                  options.majorData.submission1StartTime,
                  options.majorData.submission1EndTime
                )
              }}
              <span
                v-if="props.batchData.enablePaperSubmitNotice"
                class="des_item_s1 ml10"
                @click="noticeChange('paperSubmitNotice')"
                >提交须知</span
              >
            </div>
          </a-descriptions-item>
          <a-descriptions-item
            :column="1"
            label="二稿论文提交时间"
            v-if="options.majorData.submissionNum > 1"
          >
            <div class="value_box">
              {{
                timeFormat2(
                  options.majorData.submission2StartTime,
                  options.majorData.submission2EndTime
                )
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item
            :column="1"
            label="三稿论文提交时间"
            v-if="options.majorData.submissionNum > 2"
          >
            <div class="value_box">
              {{
                timeFormat2(
                  options.majorData.submission3StartTime,
                  options.majorData.submission3EndTime
                )
              }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>

      <div class="view_box" v-if="options.majorData?.isReply">
        <div class="title_box">
          <img class="img" src="@/assets/t_icon.png" alt="" />
          <span>本学期的答辩计划</span>
        </div>
        <a-descriptions
          title=""
          bordered
          :column="2"
          :labelStyle="{
            'text-align': 'right',
            color: '#666666',
            width: '170px',
          }"
          :contentStyle="{ color: '#666666', flex: '1' }"
        >
          <a-descriptions-item :column="1" label="答辩证明下载时间">
            <div class="value_box">
              {{
                timeFormat2(
                  options.majorData.replyCertStartTime,
                  options.majorData.replyCertEndTime
                )
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="论文答辩时间">
            <div class="value_box">
              {{
                timeFormat2(
                  options.majorData.replyStartTime,
                  options.majorData.replyEndTime
                )
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="论文答辩详细地址">
            <div class="value_box">{{ options.majorData.replyAddress }}</div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <!-- 空状态 -->
    <div v-show="!options.majorList.length" class="empty_box">
      <a-empty :image="simpleImage" />
    </div>

    <!-- 须知、下载 弹窗 -->
    <NoticeModel
      v-model:show="noticeData.show"
      :showData="noticeData.showData"
      :cancelText="noticeData.cancelText"
      :okText="noticeData.okText"
      @okChange="noticeOk"
    ></NoticeModel>

    <!-- 报名弹窗 -->
    <SignUpModel
      v-model:show="signUpData.show"
      :loading="signUpData.loading"
      :info="signUpData.notice"
      :majorList="options.majorList"
      :data="signUpData.data"
      @update-data="updateData"
    >
    </SignUpModel>
  </div>
</template>

<script setup>
import { reactive, watchEffect } from "vue";
import { Empty } from "ant-design-vue";

import { getListByBatchId } from "@/api/my_page/paper/index.js";
import { timeFormat2 } from "@/views/my_page/index.js";

import NoticeModel from "@/views/my_page/components/noticeModel.vue";
import SignUpModel from "@/views/my_page/components/signUpModel.vue";

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

const props = defineProps({
  show: {
    type: Boolean,
  },
  batchIndex: {
    type: String,
  },
  batchList: {
    type: Array,
    default: () => {
      return [];
    },
  },
  batchData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  tabsIndex: {
    type: Number,
  },
});
const emit = defineEmits(["update:batchIndex", "update:tabsIndex"]);
function batchChange(params) {
  emit("update:batchIndex", params);
}

// 筛选数据
const selectVal = reactive({
  level: "COLLEGE",
  // majorName: undefined,
  majorId: undefined,
});
const options = reactive({
  level: [
    { label: "专科", value: "COLLEGE" },
    { label: "本科", value: "UNDERGRADUATE" },
  ],
  majorList: [], // 专业选择器数据列表
  specialityList: [], // 专业数据列表
  majorData: {}, // 当前选中的专业数据
});
watchEffect(() => {
  if (props.show && props.batchIndex) {
    getBatchMajorList();
  }
});
function levelChange() {
  getBatchMajorList();
}
function majorChange(params) {
  options.majorData = options.specialityList.find((item) => item.id == params);
  // console.log("options.majorData", options.majorData);
}
// 批次专业
function getBatchMajorList() {
  let params = {
    paperBatchId: props.batchIndex,
    education: selectVal.level,
    // majorSearch: selectVal.majorName,
  };
  getListByBatchId(params)
    .then((res) => {
      // console.log("批次专业===", res);
      let list = [];
      if (res.length) {
        res.forEach((item) => {
          list.push({
            label: item.majorName,
            value: item.id,
            id: item.id,
            majorCode: item.majorCode,
          });
        });
        selectVal.majorId = list[0].value;
        options.majorData = res[0];
        options.majorList = list;
        options.specialityList = res;
      } else {
        options.majorList = [];
        selectVal.majorId = undefined;
        options.majorData = {};
        options.specialityList = res;
      }
    })
    .catch((err) => {
      console.log("err===", err);
    });
}

function submitChange() {
  console.log("提交====");
}

// 须知弹窗
const noticeData = reactive({
  show: false,
  showData: {
    title: "",
    content: "",
  },
  cancelText: false,
  okText: "确定",
  type: undefined,
});
function noticeOk(callback) {
  if (noticeData.type) {
    console.log("下载==");
  }
  callback();
}
function noticeChange(key, type) {
  noticeData.type = type;
  let titleObj = {
    signNotice: "报名须知", // props.batchData
    payNotice: "缴费须知", // props.batchData
    proposalReportNotice: "开题须知", // props.batchData
    paperSubmitNotice: "提交须知", // options.majorData
  };
  // let content = "";
  // if (key=='paperSubmitNotice') { // 一稿提价须知
  //     content = options.majorData[key];
  // } else {
  //     content = props.batchData[key];
  // }
  noticeData.showData = {
    title: titleObj[key],
    content: props.batchData[key],
  };
  if (type) {
    noticeData.cancelText = "取消";
    noticeData.okText = "下载";
  } else {
    noticeData.cancelText = false;
    noticeData.okText = "确定";
  }

  noticeData.show = true;
}

// 报名数据
const signUpData = reactive({
  state: 1,
  stateObj: {
    0: { state: "未报名", txt: "立即报名" }, // 报名须知弹框，提交资料确认后提示报名成功
    1: { state: "已报名", txt: "点击查看" },
  },

  // 弹窗
  show: false,
  title: "",
  notice: "",
  loading: false,
  data: {},
});
function operateChange() {
  if (options.majorData.isSignUp == 1) {
    emit("update:tabsIndex", 0);
    return;
  }
  signUpData.notice = props.batchData.signNotice;
  signUpData.data = {
    majorId: selectVal.majorId,
    paperBatchMajorId: selectVal.majorId,
  };
  signUpData.show = true;
}
function updateData() {
  getBatchMajorList();
}
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";

.paper_entry_box {
  width: 100%;
}

.screen_box {
  display: flex;
  align-items: center;
}
.screen_item {
  margin-left: 20px;
  display: flex;
  align-items: center;
  .label {
    min-width: max-content;
  }
}
.icon_btn {
  padding: 0 5px;
  color: #666666;
  cursor: pointer;
  &:hover {
    background: rgba($color: #000000, $alpha: 0.03);
  }
  .s1 {
    padding-left: 5px;
  }
}

.ask_my_paper_box {
  width: 100%;
}

.title_box {
  margin: 20px 0 7px;
  display: flex;
  align-items: center;
  .img {
    width: 15px;
    margin-right: 3px;
  }
  span {
    font-weight: 600;
    color: #666666;
  }
}
.des_item_s1 {
  color: $primary-color;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.ml10 {
  margin-left: 10px;
}
.view_box {
  margin-top: 30px;
}

.value_box {
  min-width: 380px;
  max-width: 600px;
}

.empty_box {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
}
</style>
